"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _config = require("../../config");
var _Translations = require("react-platform-components/dist/Translations");
var _reactRouterDom = require("react-router-dom");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function SubscriptionsProducts(props) {
  var params = (0, _reactRouterDom.useParams)();
  var history = (0, _reactRouterDom.useHistory)();
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedProducts = _useState2[0],
    setSelectedProducts = _useState2[1];
  var products = (0, _reactRedux.useSelector)(function (state) {
    return state.ProductReducer.products;
  });
  (0, _react.useEffect)(function () {
    dispatch({
      type: 'FETCH_PRODUCTS'
    });
  }, [dispatch]);
  var isSelected = function isSelected(index) {
    return selectedProducts.indexOf(index) !== -1;
  };
  var handleClick = function handleClick(index) {
    var selectedIndex = selectedProducts.indexOf(index);
    var newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedProducts, index);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedProducts.slice(1));
    } else if (selectedIndex === selectedProducts.length - 1) {
      newSelected = newSelected.concat(selectedProducts.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selectedProducts.slice(0, selectedIndex), selectedProducts.slice(selectedIndex + 1));
    }
    setSelectedProducts(newSelected);
  };
  var addPickedProducts = function addPickedProducts() {
    var pickedProducts = [];
    products.forEach(function (element) {
      if (selectedProducts.indexOf(element.id) !== -1) {
        pickedProducts.push(element);
      }
    });
    dispatch({
      type: 'PICKED_PRODUCTS',
      products: pickedProducts,
      uuid: params.uuid,
      option_uuid: params.option_uuid,
      history: history
    });
  };
  var location = history.location;
  return /*#__PURE__*/_react.default.createElement(_core.Paper, {
    className: "m-8"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    className: "py-4 px-8"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h4"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Pick products",
    defaultMessage: "Pick products"
  }))), location.state && location.state.subscription && location.state.subscription.description && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    className: "py-4 px-8"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "subtitle2"
  }, location.state.subscription.description)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    className: "px-8"
  }, products.length > 0 ? /*#__PURE__*/_react.default.createElement(_core.List, null, products.map(function (product, index) {
    var isProductSelected = isSelected(product.id);
    return /*#__PURE__*/_react.default.createElement(_core.ListItem, {
      key: index,
      button: true,
      onClick: function onClick() {
        return handleClick(product.id);
      }
    }, /*#__PURE__*/_react.default.createElement(_core.ListItemAvatar, null, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
      src: "".concat(_config.STATIC_PATH, "assets/images/logo.png")
    })), /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
      primary: product.category.name,
      secondary: product.description
    }), /*#__PURE__*/_react.default.createElement(_core.ListItemSecondaryAction, null, /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      edge: "end",
      checked: isProductSelected,
      value: product.id,
      onChange: function onChange() {
        return handleClick(product.id);
      }
    })));
  })) : /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 12,
    className: "py-12",
    alignItems: "center",
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    className: "mr-4"
  }, "info")), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "no results...",
    defaultMessage: "no results..."
  }))))), products.length > 0 && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 12,
    justify: "flex-end",
    className: "px-8 py-4"
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    disabled: selectedProducts.length > 0 ? false : true,
    variant: "contained",
    color: "primary",
    onClick: addPickedProducts
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Validate",
    defaultMessage: "Validate"
  })))));
}
var _default = SubscriptionsProducts;
exports.default = _default;